import React from 'react'

import { Grid, Button } from '@material-ui/core'
import { FavoriteBorder } from '@material-ui/icons'
import TransferActionItem from './TransferActionItem'
import { useTranslation } from 'react-i18next'

function DashboardActions({ view, setView }) {
  const { t } = useTranslation()
  return (
    <Grid container justifyContent="space-between" alignItems="center" className="userDashboardActions">
      <Grid item md={6} sm={12}>
        <Grid container justifyContent="flex-start" alignItems="center" className="userDashboardActions__leftBtn">
          <TransferActionItem icon={FavoriteBorder} text={t('bankTransfer')} />
          <TransferActionItem icon={FavoriteBorder} text={t('transferWay2')} />
        </Grid>
      </Grid>
      <Grid item md={6} sm={12}>
        <Grid container justifyContent="flex-end" alignItems="center" className="userActionsBtns">
          <Grid item>
            <Button
              variant="outlined"
              className={view === 'dashboard' ? 'btn--bue' : ''}
              onClick={() => setView('dashboard')}
            >
              {t('dashboard')}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              className={view === 'myTemplates' ? 'btn--bue' : ''}
              onClick={() => setView('myTemplates')}
            >
              {t('myTemplates')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DashboardActions
